import type { Components } from '@mui/material/styles';

import type { Theme } from '../theme/types';

export const MuiAlert = {
  styleOverrides: {
    message: { fontWeight: 500 },
  },
} satisfies Components<Theme>['MuiAlert'];
